(function() {
    'use strict';

    angular
        .module('gatewayApp')
        .controller('RoleDeleteController',RoleDeleteController);

    RoleDeleteController.$inject = ['$uibModalInstance', 'entity', 'Role', 'GlobalValues', 'ScreenLog','$scope'];

    function RoleDeleteController($uibModalInstance, entity, Role, GlobalValues, ScreenLog,$scope) {
        var vm = this;

        vm.role = entity;
        //ScreenLog.screenLog({'entityName': 'OrganisationRole', 'entityRecordId': vm.role.id, 'action': 'DELETE'});
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;
        $scope.clicked=false;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Role.delete({"orgId":GlobalValues.getCorpId(),id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
